import { createSlice } from "@reduxjs/toolkit";

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setPermissions: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            // return [...state, ...action.payload]
            return []
        },
        update: (state, action) => {
            // const foundedIndex = state.findIndex((unit) => unit.id === action.payload?.id);
            // if (foundedIndex !== -1) {
            //     state[foundedIndex] = action.payload
            // }
            // return state
            return []
        },
        remove: (state, action) => {
            const foundedIndex = state.findIndex((unit) => unit.id === action.payload?.id);
            if (foundedIndex) {
                return state.splice(foundedIndex, 1)
            }
            return state
        }
    }
});

export const {
    setPermissions, 
    empty,
    update,
    remove,
    add
} = permissionsSlice.actions;

export default permissionsSlice.reducer